export default __webpack_public_path__ + "static/media/bg.f391da98.jpg";